import type { LotStatus } from "api-types/modelTypes";

interface LotStatusOption {
  value: LotStatus;
  label: string;
}

export const LotStatusOptions: LotStatusOption[] = [
  { value: "unavailable", label: "Unavailable" },
  { value: "available", label: "Available" },
  { value: "pending", label: "Pending" },
  { value: "sold", label: "Sold" },
  { value: "closed", label: "Closed" },
];
